/**
 * WebOs - Utilitaires de chemins
 *
 * Gère les chemins relatifs pour le déploiement en sous-dossier.
 */

/**
 * Détecte le chemin de base de l'application
 * (pour les déploiements en sous-dossier)
 */
function detectBasePath() {
  // Essayer de récupérer depuis le script courant
  const scripts = document.getElementsByTagName('script');
  for (const script of scripts) {
    if (script.src && script.src.includes('assets/')) {
      const url = new URL(script.src);
      const idx = url.pathname.indexOf('/assets/');
      if (idx !== -1) {
        return url.pathname.substring(0, idx + 1);
      }
    }
  }

  // Fallback: utiliser le pathname de la page
  let pathname = window.location.pathname;

  // Si on est sur un fichier, prendre le dossier parent
  if (pathname.endsWith('.html') || pathname.endsWith('/')) {
    if (!pathname.endsWith('/')) {
      pathname = pathname.substring(0, pathname.lastIndexOf('/') + 1);
    }
  } else {
    pathname += '/';
  }

  return pathname;
}

// Chemin de base global (calculé une fois)
let _basePath = null;

/**
 * Retourne le chemin de base de l'application
 */
export function getBasePath() {
  if (_basePath === null) {
    _basePath = detectBasePath();
  }
  return _basePath;
}

/**
 * Construit une URL VFS à partir d'un chemin de fichier
 * @param {string} filePath - Chemin du fichier (ex: /usr/bin/nano/nano.js)
 * @returns {string} URL complète (ex: /sous-dossier/fs/usr/bin/nano/nano.js)
 */
export function getVfsUrl(filePath) {
  const base = getBasePath();
  // S'assurer que filePath commence par /
  const path = filePath.startsWith('/') ? filePath : '/' + filePath;
  return base + 'fs' + path;
}

/**
 * Construit une URL de package
 * @param {string} packagePath - Chemin relatif du package
 * @returns {string} URL complète
 */
export function getPackageUrl(packagePath) {
  const base = getBasePath();
  return base + 'packages/' + packagePath;
}
